import { Component, OnInit, OnDestroy, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { Company } from 'src/app/model/company';
import { MainContainerService } from 'src/app/service/main-container.service';
import { Subscription } from 'rxjs';
import { Location } from 'src/app/model/location';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { Constant } from '../constant';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { MessagingService } from 'src/app/service/MessageService/messaging.service';
import { ToastService } from 'src/app/service/toast.service';
import { Router } from '@angular/router';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import moment from 'moment';
import { ErrorLog } from 'src/app/model/Common/error-log';
import { APIFactoryEndPoints } from '../apifactory-end-points';
// import { OktaAuth } from '@okta/okta-auth-js';
import { getWindow } from 'ssr-window';
import { MatCard } from "@angular/material/card";
import { MatFormField } from '@angular/material/form-field';
import { VoiceService } from '../Voice-Service/Voice-Service';
@Component({
  selector: 'app-choose-location-dialog',
  templateUrl: './choose-location-dialog.component.html',
  styleUrls: ['./choose-location-dialog.component.css']
})
export class ChooseLocationDialogComponent implements OnInit {

  companyList: Company[] = [];
  parentLocList: Location[] = [];
  locList: Location[] = [];
  form: UntypedFormGroup;

  locationDialogForm: UntypedFormGroup;

  private logoutSubscription: Subscription;

  //Variable
  parentLocationName: string;
  constant: Constant = new Constant();
  //subscriptions
  private companySubscription: Subscription;
  private parentLocSubscription: Subscription;
  private locSubscription: Subscription;
  private getParentLocationSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  dialogData: any;
  valuePatched: boolean;
  errorLog: ErrorLog = new ErrorLog();
  locCode: number;
  products: any[];

  constructor(
    // @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    // public authService: OktaAuthStateService,
    public router: Router,
    public persistenceService: LocalStorageService,
    private mainContainerService: MainContainerService,
    private toastService: ToastService,
    private apiFactory: APIFactoryEndPoints,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<ChooseLocationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) savedData,
    private voiceService: VoiceService,
    private http: HttpClient
  ) {
    this.dialogData = savedData;
    if (this.dialogData.company) {
      this.valuePatched = false;
    }
  }

  ngOnInit() {

    this.onFormSetup();
    this.onLocationDialogFormSetUp();
    this.getCompanyList();
    if (this.dialogData.company) {
      this.valuePatched = false;
    }
    this.voiceService.products$.subscribe((res) => {
      this.products = res;
    });
  }
 start() {
    this.voiceService.startListening();
  }

  stop() {
    this.voiceService.stopListening();
  }  
 

  callCustomer() {
    const data = {
      phone: '+916370952176'
    };

    this.http.post('http://localhost:5000/api/call', data)
      .subscribe({
        next: (res) => console.log('Call triggered', res),
        error: (err) => console.error('Error:', err)
      });
  }
  
  
  ngOnDestroy() {
    if (this.companySubscription !== undefined)
      this.companySubscription.unsubscribe();
    if (this.parentLocSubscription !== undefined)
      this.parentLocSubscription.unsubscribe();
    if (this.locSubscription !== undefined)
      this.locSubscription.unsubscribe();
    if (this.getParentLocationSubscription !== undefined)
      this.getParentLocationSubscription.unsubscribe();
    if (this.logoutSubscription !== undefined)
      this.logoutSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  onFormSetup() {
    this.form = this.fb.group({
      companyRefNo: ['', Validators.required],
      parentLocRefNo: ['', Validators.required],
      locationRefNo: ['', Validators.required],
    });
  }

  onLocationDialogFormSetUp() {
    this.locationDialogForm = this.fb.group({
      company: ['', Validators.required],
      location: ['', Validators.required],
      parentLocationName: ['', Validators.required],
      parentLocRefNo: ['', Validators.required],
    })
  }


  getCompanyList() {
    this.companySubscription = this.mainContainerService.getAllCompaniesByUser().subscribe((data) => {
      this.companyList = Array.isArray(data) ? data : [];
      this.getParentLocaitonsList();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getCompanyList", error);
      });
  }

  getParentLocaitonsList() {
    this.parentLocSubscription = this.mainContainerService.getParentLocationsByUser().subscribe((data) => {

      if (Array.isArray(data)) {
        this.parentLocList = data;
      } else {
        this.parentLocList = []
      }
      if (!this.valuePatched && this.dialogData.company) {
        this.onCompanySelect(this.dialogData.company.refNo);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getParentLocaitonsList", error);
      });
  }

  onCompanySelect(companyRefNo: number) {
    this.form.get('locationRefNo').reset();
    this.companyList.forEach(element => {
      if (element.refNo == companyRefNo) {
        this.locationDialogForm.get('company').setValue(element);
      }
    })
    let parentLocCode = this.form.get('parentLocRefNo').value
    if (parentLocCode) {
      this.getLocationsByParentLocAndCompanyCode(parentLocCode, companyRefNo);
    }
    if (!this.valuePatched && this.dialogData.company) {
      this.onParentLocationSelect(this.dialogData.parentLocRefNo);
    }
  }

  onParentLocationSelect(parentLocRefNo: number) {
    this.form.get('locationRefNo').reset();
    this.parentLocList.forEach(element => {
      if (element.refNo == parentLocRefNo) {
        this.locationDialogForm.patchValue({
          parentLocationName: element.locationName,
          parentLocRefNo: element.refNo
        })
      }
    });
    if (!this.valuePatched && this.dialogData.company) {
      this.form.patchValue({
        companyRefNo: this.dialogData.company.refNo,
        parentLocRefNo: this.dialogData.parentLocRefNo,
        locationRefNo: this.dialogData.location.refNo
      })
    }
    let companyCode = this.form.get('companyRefNo').value
    if (companyCode) {
      this.getLocationsByParentLocAndCompanyCode(parentLocRefNo, companyCode);
    }
  }

  getLocationsByParentLocAndCompanyCode(parentLocCode: number, companyCode: number) {
    this.locList = [];
    this.parentLocSubscription = this.mainContainerService.getLocationsByUserAndParentLocIdOrRefNoAndCompanyCode(parentLocCode, companyCode).subscribe((data) => {
      if (Array.isArray(data)) {
        this.locList = data;
      } else {
        this.locList = [];
      }

      if (!this.valuePatched && this.dialogData.company) {
        this.onLocationSelect(this.dialogData.location.refNo);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getLocationsByParentLocAndCompanyCode", error);
      });
  }


  onLocationSelect(locationRefNo: number) {
    this.locList.forEach(element => {
      if (element.refNo == locationRefNo) {
        this.locationDialogForm.get('location').setValue(element);
        this.valuePatched = true;
        this.locCode = element.refNo;
      }
    });

  }

  onProceedClick() {
    if (this.form.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    this.persistenceService.set("company", JSON.stringify(this.locationDialogForm.get('company').value));
    this.persistenceService.set("location", JSON.stringify(this.locationDialogForm.get('location').value));
    this.persistenceService.set("locId", JSON.stringify(this.locCode));
    this.persistenceService.set("parentLocationName", JSON.stringify(this.locationDialogForm.get('parentLocationName').value));
    this.persistenceService.set("parentLocRefNo", JSON.stringify(this.locationDialogForm.get('parentLocRefNo').value));
    this.persistenceService.set('userDetail', JSON.stringify(this.locationDialogForm.value))
    this.persistenceService.set('locRefNo', JSON.stringify(this.locCode))
    if (this.router.url.includes('/login'))
      this.router.navigateByUrl('/dashboard');
    this.dialogRef.close(this.locationDialogForm.value);


  }

  onBackClick() {
    // getWindow().location.reload();
    // if (!this.router.url.includes("okta-login"))
    if (!this.router.url.includes("login"))
      this.dialogRef.close();
    else
      this.toastService.showErrorToast(this.constant.notAllowToast)
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "ChooseLocationDialog";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = this.persistenceService.get('OS');
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    this.insertErrorLogSubscription = this.mainContainerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    });
  }
}